import { useEffect, useState } from "react";
import { Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PortalShell } from "@/components/AppHeader";

export const DeleteAccount = () => {
  const { logout } = useAuth();
  const [check, setCheck] = useState(null);
  const [open, setOpen] = useState(false);
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/me/deletion-check").then(({ data }) => setCheck(data)).catch(() => {}); }, []);
  const del = async () => {
    setBusy(true);
    try { await api.delete("/me", { data: { password: pw } }); toast.success("Your account was deleted"); logout(); }
    catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  return (
    <div className="lux-card space-y-3 border-red-500/20 p-5 sm:p-6" data-testid="delete-account-card">
      <p className="lux-eyebrow !text-red-300">Delete account</p>
      <p className="text-sm text-zinc-400">Permanently removes your name, email, phone, location history, ID images and saved card. Trip and payment records stay for accounting without your details.</p>
      {check && !check.allowed && <p data-testid="delete-account-blocked" className="text-sm text-amber-300">{check.reason}</p>}
      {!open ? (
        <button data-testid="delete-account-button" disabled={check && !check.allowed} onClick={() => setOpen(true)} className="btn-danger !px-4 !py-2 text-sm"><Trash2 className="h-4 w-4" /> Delete my account</button>
      ) : (
        <div className="space-y-2">
          <input type="password" data-testid="delete-account-password" className="lux-input" placeholder="Confirm your password" value={pw} onChange={(e) => setPw(e.target.value)} />
          <div className="flex gap-2">
            <button data-testid="delete-account-confirm" disabled={!pw || busy} onClick={del} className="btn-danger !px-4 !py-2 text-sm">{busy && <Loader2 className="h-4 w-4 animate-spin" />} Delete permanently</button>
            <button data-testid="delete-account-cancel" onClick={() => setOpen(false)} className="btn-outline-gold !px-4 !py-2 text-sm">Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default function AccountPage() {
  const { user } = useAuth();
  return (
    <PortalShell>
      <div className="mx-auto max-w-xl space-y-6" data-testid="account-page">
        <h1 className="text-3xl font-semibold text-amber-50">Account</h1>
        <div className="lux-card space-y-1 p-5 text-sm sm:p-6">
          <p className="text-amber-100" data-testid="account-name">{user.business_name || user.name}</p>
          <p className="text-zinc-400">{user.email} · {user.phone}</p>
        </div>
        <DeleteAccount />
      </div>
    </PortalShell>
  );
}
